//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatisticsNumbersItem from "~/components/profile/statistics-numbers/StatisticsNumbersItem.vue";
import Loader from "~/components/loader/Loader.vue";
import {downloadFile} from "../../../helpers/getFile.js";
import Breadcrumbs from "~/components/page/PageBreadcrumbs.vue";
import userAuthorization from "~/mixin/user-authorization";

export default {
  mixins: [userAuthorization],
  name: "ProfileStatistic",
  data() {
    return {
      downloadLink: null,
      isLoading: false,
      currentStatistic: null,
    };
  },

  async created() {
    await this.getUserNumbers();
  },

  computed: {
    getBreadcrumbs() {
      const breadcrumbs = [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: this.$route.path, title: this.$t('profile.queryStatistics.title')},
      ];
      return breadcrumbs;
    },
  },

  methods: {
    async getUserNumbers() {
      this.isLoading = true;
      const currentStatistic = await this.$api.agent.transport
        .get("sms-users/numbers")
        .catch((err) => {});
      this.currentStatistic = currentStatistic?.data || [];
      this.isLoading = false;
    },

    async getNumbersExel() {
      const link = await this.$api.agent.transport
        .get("sms-users/numbers-excel")
        .then(res => {
          return res.data;
        })
        .catch((err) => {});

      await downloadFile({
        linkFile: link,
        $cookies: this.$cookies
      });

    },
  },
  components: {
    Loader,
    Breadcrumbs,
    StatisticsNumbersItem
  },
};
